'use strict';

function trim(str) {
  return str.trim();
}

module.exports = trim;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/trim.js
// module id = 81
// module chunks = 0